<div class="overflow-hidden animate__animated animate__fadeIn ">
    <app-banner [data]="dataHeader" [type]="'slider'" id="scrollhome"></app-banner>
    <div class="flex flex-col px-5 mt-5 sm:px-5 md:px-10 lg:px-10 xl:px-20 2xl:px-32">
        <app-features [data]="dataFeatures" [type]="'products'"></app-features>
        <br>
        <app-features [data]="dataAbout" [type]="'aboutus'"></app-features>
        <div id="scrollvalues">
            <app-accordion [data]="dataValues" class="block md:hidden"></app-accordion>
            <app-tabs [data]="dataValues" [type]="'values'" class="hidden md:block"></app-tabs>
        </div>
        <br><br>
        <br>
        <div class="w-full" id="scrollcontacts">
            <app-forms [type]="'contacts'"></app-forms>
        </div>
    </div>
</div>